import db from "./db";

export async function getDBObjects(collectionName, month, year) {
  const parsedMonth = parseInt(month) - 1;
  const parsedYear = parseInt(year);
  try {
    const objects = await db[collectionName].toArray();
    if (!month && !year) {
      return objects;
    } else {
      const filtered = objects.filter((item) => {
        if (!item.date) return false;
        const dateObj = new Date(item.date);
        return (
          dateObj.getMonth() === parsedMonth &&
          dateObj.getFullYear() === parsedYear
        );
      });
      return filtered;
    }
  } catch (error) {
    console.error("Error loading objects:", error);
    return [];
  }
}

export async function getDBObjectsBySupplier(collectionName, supplier) {
  try {
    const objects = await db[collectionName].toArray();
    if (!supplier) {
      return [];
    } else {
      const filtered = objects.filter((item) => {
        if (!item.supplier) return false;
        return item.supplier?.id === supplier?.id;
      });
      return filtered;
    }
  } catch (error) {
    console.error("Error loading objects:", error);
    return [];
  }
}
